import React, { useState, useEffect } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import InputBox from "../../components/common/InputBox";
import Div from "../../components/common/Div";
import { Tex } from "react-tex";
import { useHistory } from "react-router-dom";
import {
  tenzero,
  tentwentyfive,
  NumberToLetter,
  fixMarginQuestionButtons,
  correctColor,
  wrongColor,
  missingColor,
  fixOptions,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import { Lightbulb } from "@mui/icons-material";
import { Typography } from "@mui/material";
import {formatLatexText} from "../../utils/formatLaTex";

export default function Res_Type(props) {
  const [questionRerender, setQuestionRerender] = useState(false);

  const question = props.question;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const submissionResults = props.submissionResults;

  var options;

  if (props.options === undefined) options = [];
  else options = props.options[questionNumber];

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      let formattedText = formatLatexText(options[i].text);
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
                fontSize: "0.9rem",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                  <Latex>{formattedText}</Latex>
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  const history = useHistory();

  function getButton() {
    if (question.solution.length === 0) return <></>;
    else {
      return (
        <>
          <Button
            backgroundColor={"#FFFFFF"}
            borderRadius={"5px"}
            padding={"5px"}
            width={"220px"}
            marginTop={"10px"}
            margin={"margin: 0 auto"}
            onClick={() => {
              history.push("/solution", {
                solution: question.solution,
                question: props.questionNumber,
              });
            }}
          >
            <Lightbulb></Lightbulb>
          </Button>
        </>
      );
    }
  }

  function colorGrade() {
    if (question.number == submission[questionNumber][0]) return correctColor();
    else return wrongColor();
    return submissionResults[questionNumber] == "CORRECT"
      ? correctColor()
      : wrongColor();
  }

  return (
    <Div
      backgroundColor={"#FFFFFF"}
      height={"100%"}
      margin={tenzero}
      borderRadius={"5px"}
      padding={"10px"}
    >
      <Div overflowY={"auto"} height={"80%"}>
        <Div margin={tenzero}>
          <Typography
            fontWeight={"bold"}
            color={"#00112e"}
            textAlign={"left"}
            padding={"10px"}
            style={{ fontSize: "1.1rem" }}
          >
            Question {questionNumber + 1}
          </Typography>
          <hr
            style={{
              borderColor: "rgb(0, 17, 46)",
              borderWidth: "1px",
              borderStyle: "solid",
              width: "95%",
            }}
          />
          <QuestionText question={question} />
          <Image
            src={question.url}
            width="250px"
            style={{ display: "block", margin: "0 auto" }}
          />
          {Options()}
        </Div>
      </Div>

      <div
        style={{
          backgroundColor: "#ccc",
          padding: "5px",
          borderRadius: "10px",
          margin: "20px",
        }}
      >
        <div
          style={{
            fontSize: "1rem",
            padding: "10px",
            paddingBottom: "10px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "left",
            color: "rgb(0, 17, 46)",
            width: "100%",
            margin: "0 auto",
          }}
        >
          Your Answer
        </div>

        <Div padding={"10px 0"}>
          <Div
            width={"200px"}
            backgroundColor={
              submission[questionNumber][0] !== ""
                ? colorGrade()
                : missingColor()
            }
            margin={"0 auto 0 auto"}
            fontSize={"0.9rem"}
            padding={"10px"}
            borderRadius={"5px"}
          >
            {options.length > 0
              ? submission[questionNumber][0] !== ""
                ? submission[questionNumber][0] +
                  (submission[questionNumber][1] !== ""
                    ? " (Unit: "
                        .concat(submission[questionNumber][1])
                        .concat(")")
                    : " (No Unit Chosen)")
                : "Not Answered"
              : submission[questionNumber][0] !== ""
              ? submission[questionNumber][0]
              : "Not Answered"}
          </Div>
          {getButton()}
        </Div>
      </div>
    </Div>
  );
}
